var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlGreenNine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4517_410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9922 34.0002H28.9492C29.4993 34.0002 29.9453 33.5542 29.9453 33.0041V22.7111H17.9922V34.0002Z",
    fill: "#92B893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04688 33.0041C4.04688 33.5542 4.49286 34.0002 5.04297 34.0002H16V22.7111H4.04688V33.0041Z",
    fill: "#92B893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4249 14.7422H1.02449C0.71046 14.7422 0.405124 14.8759 0.212081 15.1236C-0.0587904 15.4711 -0.0678881 15.9439 0.171573 16.2972L3.16842 20.7188H16.0039L12.2495 15.1794C12.0641 14.9059 11.7553 14.7422 11.4249 14.7422Z",
    fill: "#92B893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7841 15.1238C33.591 14.8761 33.2857 14.7423 32.9716 14.7423H22.5712C22.2408 14.7423 21.9319 14.9061 21.7466 15.1796L17.9922 20.7189H30.8277L33.8245 16.2973C34.064 15.944 34.0549 15.4712 33.7841 15.1238Z",
    fill: "#92B893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7072 0.717226C27.5266 0.6475 23.2482 -0.970688 20.0139 0.896523C18.5544 1.73915 17.6034 3.12093 16.9963 4.40118C16.3892 3.12087 15.4381 1.73915 13.9787 0.896523C10.7447 -0.970621 6.46599 0.6475 6.28544 0.717226C5.84842 0.886164 5.58817 1.33686 5.66042 1.79985C5.69024 1.9911 6.42821 6.50559 9.66226 8.37274C10.8364 9.05061 12.1481 9.26915 13.3515 9.26915C14.3587 9.26915 15.2894 9.11615 16.0003 8.95127V8.19796L11.3225 5.49721C10.846 5.22216 10.6828 4.61295 10.9579 4.13655C11.233 3.66009 11.8422 3.49679 12.3186 3.77198L16.9963 6.47266L21.6741 3.77191C22.1505 3.49686 22.7598 3.66002 23.0348 4.13648C23.3099 4.61288 23.1466 5.22209 22.6702 5.49715L17.9924 8.19796V8.9512C18.7032 9.11609 19.6339 9.26909 20.6411 9.26909C21.8444 9.26909 23.1565 9.05048 24.3304 8.37267C27.5645 6.50553 28.3024 1.99103 28.3322 1.79978C28.4044 1.33686 28.1442 0.886164 27.7072 0.717226Z",
    fill: "#92B893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.95019V14.7403C16 15.2904 16.446 15.7364 16.9961 15.7364C17.5462 15.7364 17.9922 15.2904 17.9922 14.7403V8.95026C17.5745 8.85337 17.2326 8.75237 16.9961 8.67593C16.7596 8.7523 16.4177 8.85331 16 8.95019Z",
    fill: "#92B893"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4517_410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlGreenNine);
export default __webpack_public_path__ + "static/media/al-green-nine.d1e9b05a959d74ecb7617e82941fa316.svg";
export { ForwardRef as ReactComponent };